<template>
  <div class="w-full overflow-y-auto">
    <div class="w-full max-w-[1160px] min-w-[463px] pt-[36px] px-[32px] flex flex-col mx-auto min-h-[100vh]">
      <!-- Header -->
      <PageHeader
        title="Добавление шаблона"
        subtitle="Шаблоны задач КЗС"
        withBackBtn
        @on-back="backBtnActive = true"
      />
      <!-- End Header -->
      <!-- Content -->
      <div v-if="isError" class="flex-1 min-h-0 flex">
        <v-placeholder
          message="Что-то пошло не так"
          description="Попробуйте повторить запрос <br> или обратитесь в службу поддержки"
          :icon="{ name: 'xl/mood-confuzed' }"
          class="!min-h-[70vh] h-full w-full !p-[24px]"
        >
          <template #footer>
            <p class="text-14-reg-400">Позвонить в техподдержку</p>
            <a
              class="text-v-ui-text-main text-14-reg-400 mt-[8px]"
              href="tel:88005000299"
              >8 800 500-02-99</a
            >
          </template>
        </v-placeholder>
      </div>

      <KzsTemplateForm
        v-else
        :backBtnActive="backBtnActive"
        @update:backBtnActive="updateBackBtnActive"
      />
    </div>
  </div>
</template>

<script>
import KzsTemplateForm from '@/components/Kzs/Templates/KzsTemplateForm';
import { VPlaceholder } from '@gostelemed.front/rt-doctis.designsystem';
import PageHeader from '@/components/common/PageHeader';

export default {
  name: 'KzsTemplatesAdd',
  page: {
    title: 'CRM Doctis - Шаблоны задач КЗС',
  },
  components: {
    KzsTemplateForm,
    VPlaceholder,
    PageHeader,
  },
  data() {
    return {
      isError: false,
      backBtnActive: false,
    };
  },
  methods: {
    updateBackBtnActive(value) {
      this.backBtnActive = value;
    },
  },
};
</script>
